class Optimizely {
  inferName(data) {
    const normalize = (str) => str.toLowerCase().replace(/\s/g, '-');

    return `${normalize(data.category)}.${normalize(data.action)}.${normalize(data.label)}`;
  }

  track(data) {
    const name = data.optimizelyValue;
    const inferredName = this.inferName(data);

    if (typeof window.optimizely !== 'undefined') {
      window.optimizely.push({
        type: 'event',
        eventName: name || inferredName
      });
    }
  }
}

export { Optimizely };

export default new Optimizely();
